// src/components/Tutorial/Examples/VerificationCard.js
import React from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { VerifiedUser as VerifiedIcon, Sync as SyncIcon } from '@mui/icons-material';

export default function VerificationCard() {
  return (
    <Box className="example-container" sx={{ mt: 3 }}>
      <Card sx={{ 
        borderRadius: 3, 
        boxShadow: 2,
      }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  background: 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <VerifiedIcon sx={{ color: 'white', fontSize: 28 }} />
              </Box>
              <Box>
                <Typography variant="h6" fontWeight={700}>
                  OnlyFans Subscriptions
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Connect your OF account
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Not verified state */}
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary" paragraph>
              You don't have your OF profile connected. Sync your subscriptions to leave verified reviews.
            </Typography>
            <Box
              sx={{
                maxWidth: 520,
                mx: 'auto',
                mt: 2,
                mb: 3,
                px: { xs: 2.5, sm: 3 },
                py: { xs: 1.75, sm: 2 },
                borderRadius: 3,
                background: 'linear-gradient(120deg, rgba(30,136,229,0.1), rgba(21,101,192,0.12))',
                border: '1px solid rgba(30,136,229,0.2)',
                display: 'flex',
                gap: 2,
                alignItems: 'flex-start',
                textAlign: 'left',
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  boxShadow: '0 6px 16px rgba(30,136,229,0.18)',
                }}
              >
                <VerifiedIcon sx={{ color: '#1e88e5' }} />
              </Box>
              <Box>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
                  Email login required
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                  Use your OnlyFans email + password (Google/X logins aren't supported yet).
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              size="large"
              startIcon={<SyncIcon />}
              sx={{
                background: 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)',
                fontWeight: 600,
                px: 4,
                py: 1.5,
                '&:hover': {
                  background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)',
                },
              }}
            >
              Verify with OnlyFans
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
